// extracted by mini-css-extract-plugin
export default {"innerContainer":"styles-module--innerContainer---fu9a","detailsLink":"styles-module--detailsLink--6wli-"};